import { useEffect, useState } from 'react';
import { MenuItem, Select } from '@mui/material';
import { GridRenderEditCellParams } from '@mui/x-data-grid';

import { getVehicleTypes } from '@/generated/client/targetattributes/targetattributes';
import { VehicleTypeDto } from '@/generated/model';
import { useTranslation } from 'react-i18next';

export default function VehicleTypeEditor({ params }: { params: GridRenderEditCellParams }) {
  const { id, field, row, api } = params;
  const { t } = useTranslation();
  const [vehicleTypes, setVehicleTypes] = useState<VehicleTypeDto[] | undefined>();

  useEffect(() => {
    async function loadPossibleValues() {
      const newValues = (await getVehicleTypes()).data;
      setVehicleTypes(newValues);
    }
    void loadPossibleValues();
  }, []);

  if (!vehicleTypes) {
    return <span className="target-attribute-value disabled">{t('targetAttributes.pleaseWait')}</span>;
  }
  return (
    <Select
      className="target-attribute-value"
      value={row.value.id ?? ''}
      onChange={async (e) => {
        const selected = vehicleTypes.find((vehicle) => vehicle.id === e.target.value);
        await api.setEditCellValue({ id, field, value: selected });
      }}
      autoFocus
    >
      {vehicleTypes.map((value) => (
        <MenuItem key={value.id} value={value.id}>{`${value.brand} ${value.type}`}</MenuItem>
      ))}
    </Select>
  );
}
